module.exports = __webpack_public_path__ + "img/guihuan.ba9f2aa5.png";